import Hero from "@/components/sections/Hero";
import TrustMarquee from "@/components/sections/TrustMarquee";
import ServicesBento from "@/components/sections/ServicesBento";
import StatsRow from "@/components/sections/StatsRow";
import WhyChooseUs from "@/components/sections/WhyChooseUs";
import GalleryPreview from "@/components/sections/GalleryPreview";
import Testimonials from "@/components/sections/Testimonials";
import FAQSection from "@/components/sections/FAQSection";
import ContactBlock from "@/components/sections/ContactBlock";
import Certifications from "@/components/sections/Certifications";
import CalculatorPromo from "@/components/sections/CalculatorPromo";
import FeaturedSpecialties from "@/components/sections/FeaturedSpecialties";

export default function HomePage() {
  return (
    <div data-testid="home-page">
      <Hero />
      <TrustMarquee />
      <ServicesBento />
      <StatsRow />
      <Certifications />
      <WhyChooseUs />
      <FeaturedSpecialties />
      <CalculatorPromo />
      <GalleryPreview />
      <Testimonials />
      <FAQSection />
      <ContactBlock source="homepage" />
    </div>
  );
}
